import { useSelector } from 'react-redux';

export const FullEngagements = () => useSelector(state => state.userengagements);


export const isEngaged = (store, modelId, modelType, engagement) => {

    const key = `engagement_${modelType}_${modelId}`;
    if (store[key]?.count <= 0 && store?.items?.count <= 0) return false;

    const items = (store[key]) ? store[key] : store.items;

    const fav = items?.rows.find(item => {
        if (item.modelId === modelId && item.modelType === modelType && item.engagement === engagement) {
            return true;
        }
        return false;
    })

    return (fav) ? true : false;
}